import React from 'react'
import { useTranslation } from 'react-i18next';
import FullScreenDialog from '../common/FullScreenDialog';
import MoreToComeContent from './MoreToComeContent';


interface MoreToComeDialogProps {
  open: boolean;
}

const MoreToComeDialog = (props: MoreToComeDialogProps) => {
  const { t } = useTranslation();
  return (
    <FullScreenDialog open={props.open} ariaLabel={t("common.dialog.more_to_come")}>
      <MoreToComeContent />
    </FullScreenDialog>
  )
}

export default MoreToComeDialog
